import ConfigurationContainer from "./ConfigurationContainer";
import ConfigurationStore from "./ConfigurationStore";
export default ConfigurationStore(ConfigurationContainer); 